import { GridColDef } from '@mui/x-data-grid';
import ProductReferenceCell from '../cell/ProductReferenceCell';
import ProductAttributeDisplayCell from '../cell/ProductAttributeDisplayCell';
import SalesOrgCell from '../cell/SalesOrgCell';
import IPrinters from '../../models/Indexes/iPrinters';

const Printers = (): GridColDef<IPrinters>[] => {
  return [
    {
      field: 'primaryImageWithUrlMed',
      headerName: 'Reference',
      flex: 2,
      renderCell: (params) => <ProductReferenceCell row={params.row} imageUrl={params.value} />,
      sortable: false,
      filterable: false,
    },
    {
      field: 'salesOrgDiv',
      headerName: 'Sales Org',
      flex: 2,
      renderCell: (params) => <SalesOrgCell params={params} />,
    },
    {
      field: 'catalogDisplay',
      headerName: 'Catalog',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="catalogActual" />
      ),
    },
    { field: 'productYNumber', headerName: 'Y#', flex: 2 },
    { field: 'type', headerName: 'Type', flex: 2 },
    { field: 'productDescription', headerName: 'Product Description', flex: 4 },
    {
      field: 'materialDisplay',
      headerName: 'Material',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="materialActual" />
      ),
    },
    {
      field: 'dimensionsDisplay',
      headerName: 'Dimensions',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="dimensionsActual" />
      ),
    },
    {
      field: 'colorDisplay',
      headerName: 'Color',
      flex: 3,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="colorActual" />
      ),
    },
    {
      field: 'headerDisplay',
      headerName: 'Header',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="headerActual" />
      ),
    },
    { field: 'sapStatus', headerName: 'SAP Status', flex: 2 },
  ];
};

export default Printers;
